import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const FormContainer = styled(Box)(({ theme, containerstyle }) => ({
  height: containerstyle?.height || "100vh",
  background: containerstyle?.background || "none",
  alignItems: "center",
  justifyContent: "center",
  paddingLeft: containerstyle?.paddingLeft || "none",
  paddingTop: containerstyle?.paddingTop || "none",
  marginTop: containerstyle?.marginTop || "none",
}));

const ControlContainer = styled(Box)(({ theme }) => ({
  width: "80vw",
  margin: "auto",
  backgroundColor: "#ffffff",
  borderRadius: "10px",
  padding: "20px",
  paddingTop: "10px",
  fontSize: "0.8rem !important",
  maxWidth: "1400px",
}));

export { FormContainer, ControlContainer };
